import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hrAuth';
import HRLayout from './hrComponents/Layout';
import CheckIn from './CheckIn';
import Attendance from './Attendance';
import History from './History';
import Leaves from './Leaves';
import DirectCall from './DirectCall';
import Team from './Team';
import Admin from './Admin';
import Profile from './Profile';
import './myhr.css';

function HRApp() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
                  height:'100%', color:'#6b7280', fontSize:14 }}>
      Loading HR Portal…
    </div>
  );

  if (!user) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
                  height:'100%', color:'#ef4444', fontSize:14, padding:40 }}>
      Unable to load HR Portal. Please refresh the page.
    </div>
  );

  return (
    <HRLayout>
      <Routes>
        <Route path="/"           element={<CheckIn />} />
        <Route path="attendance"  element={<Attendance />} />
        <Route path="history"     element={<History />} />
        <Route path="leaves"      element={<Leaves />} />
        <Route path="direct-call" element={<DirectCall />} />
        <Route path="team"        element={<Team />} />
        <Route path="admin"       element={<Admin />} />
        <Route path="profile"     element={<Profile />} />
        <Route path="*"           element={<Navigate to="/my-hr" replace />} />
      </Routes>
    </HRLayout>
  );
}

export default function MyHR() {
  return (
    <AuthProvider>
      <HRApp />
    </AuthProvider>
  );
}
